import React from "react";

import Training1 from "../Assets/training1.png";
import Training2 from "../Assets/training2.png";
import Training3 from "../Assets/training3.png";

const TrainingModule = ({ hideOnMobile }) => {
  return (
    <>
      <section
        className={hideOnMobile ? "d-none d-lg-block" : ""}
        id="section9"
      >
        <div className="training_module" id="training-modules">
          <div className="heading">
            <h3>
              <span>Training Module</span> at a Glance
            </h3>
          </div>
          <div className="training_module_container">
            <div className="container">
              <div className="row">
                <div className="col-lg-4">
                  <div className="fig">
                    <img src={Training1} className="img-fluid" alt="" />
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="fig">
                    <img src={Training2} className="img-fluid" alt="" />
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="fig">
                    <img src={Training3} className="img-fluid" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default TrainingModule;
